import React from "react";

const Spinner = () => (
  <div
    className="flex justify-center items-center"
    style={{
      height: "calc(100vh - 60px)",
    }}
  >
    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-green"></div>
  </div>
);

export default Spinner;
